import React, { useRef } from 'react';
import theme from 'theme';
import { ITutor } from 'types/Tutor';

import indigo from '@material-ui/core/colors/indigo';
import { Box, Typography } from '@mui/material';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const key: any = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const generateMarkerIcon = (
  fillColor: string = indigo[500]
): google.maps.Icon | google.maps.Symbol => ({
  path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  fillColor,
  fillOpacity: 1,
  scale: 2,
  strokeColor: '#FFFFFF',
  strokeWeight: 2,
  origin: new google.maps.Point(12, 23),
  anchor: new google.maps.Point(12, 23),
  scaledSize: new google.maps.Size(17, 17),
  size: new google.maps.Size(17, 17),
});

type Props = {
  tutor: ITutor;
};

export const TutorLocationMap: React.FC<Props> = ({ tutor }) => {
  const map = useRef<google.maps.Map | null>(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: key,
  });

  const onLoad = (mapRef: google.maps.Map) => {
    map.current = mapRef;
  };

  const onUnmount = React.useCallback(function callback(map) {
    map.current = null;
  }, []);

  const coordinates = tutor?.location?.latitude
    ? tutor?.location
    : tutor?.address?.location;

  if (!coordinates?.latitude) {
    return <Typography>Localização do tutor não disponível</Typography>;
  }

  return (
    <Box
      style={{
        height: '100%',
        width: '100%',
      }}
    >
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={{ lat: coordinates.latitude, lng: coordinates.longitude }}
          zoom={14}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          <Marker
            position={{
              lat: coordinates.latitude,
              lng: coordinates.longitude,
            }}
            icon={generateMarkerIcon(theme.palette.primary.main)}
          />
        </GoogleMap>
      )}
    </Box>
  );
};
